import { Injectable, ErrorHandler } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { AuthenticationService } from '../service/authentication.service';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {

  constructor(private authenticationService: AuthenticationService) {
    Sentry.init({
      dsn: "https://4b7ac1fd5ebb49e58acee56b93d99e7c@o1092194.ingest.sentry.io/6110330",
      maxValueLength: 100000,
      beforeSend(event) {
        // Modify the event here
        try {
          if (event.message && !event.message.toString().includes('this.colors.getColor') && !event.message.toString().includes('Compiling') && !event.message.toString().includes('Warning'))
            return event;
        }
        catch {
          return event;
        }
      },
      tracesSampleRate: 1.0, // We recommend adjusting this in production
    });
	}

  handleError(error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    Sentry.setUser({
      'user': this.authenticationService.currentUserValue});
    Sentry.captureException(error.originalError || error);
	}
}
